import { create } from 'zustand';

interface EditorState {
  /** Whether the current page has unsaved changes */
  isDirty: boolean;
  /** Mark the editor as dirty (has unsaved changes) */
  setDirty: (dirty: boolean) => void;
  /** Whether a save is in progress */
  isSaving: boolean;
  /** Set save-in-progress state */
  setSaving: (saving: boolean) => void;
  /** Whether the left sidebar is collapsed */
  sidebarCollapsed: boolean;
  /** Toggle left sidebar */
  toggleSidebar: () => void;
  /** Set sidebar collapsed state */
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useEditorStore = create<EditorState>((set) => ({
  isDirty: false,
  setDirty: (dirty) => set({ isDirty: dirty }),
  isSaving: false,
  setSaving: (saving) => set({ isSaving: saving }),
  sidebarCollapsed: false,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
}));
